import { inject as service } from '@ember/service';
import Mixin from '@ember/object/mixin';

/**
 * Mixin for enforcing buyer only routes.
 *
 * You should implement the _redirectUnauthorizedUser to specify where to go if a non-buyer or non-admin comes to this route.
 */
export default Mixin.create({
  /**
   * Register services
   */
  session: service(),
  router: service(),

  /**
   * @inheritDoc
   */
  beforeModel(transition) {
    const currentUser = this.get('session.currentUser');

    const isAllowed = currentUser &&
      (currentUser.get('isBuyer')) ||
      (currentUser.get('isAdmin') && this._isAllowAdmins());

    if (!isAllowed) {
      this._redirectUnauthorizedUser(transition);
    }
  },

  /**
   * Overridable function to allow admins into buyer only routes or not.
   *
   * @return {boolean}
   * @private
   */
  _isAllowAdmins() {
    return false;
  },

  /**
   * @protected
   */
  _redirectUnauthorizedUser() {
    this.get('router').transitionTo('start');
  },
});
